import { gql } from 'apollo-boost';

export const CATEGORIES = gql`
  query CATEGORIES {
    eventCategories {
      id
      name
    }
  }
`;

export const SEARCH_EVENTS = gql`
  query EVENTS($search: EventSearchInput) {
    events(search: $search) {
      total
      page
      docs {
        id
        name
        date
        startTime
        endTime
        open
        waitlist
        published
        constraintCapacityTotal
        coordinator {
          id
          firstName
          lastName
          avatar
        }
        leader {
          id
          firstName
          lastName
          avatar
        }
      }
    }
  }
`;

export const EVENT_ATTENDEES = gql`
  query($id: ID, $waitlist: Boolean) {
    event(id: $id) {
      id
      registrations(waitlist: $waitlist) {
        id
        status
        createdAt
        donationAmount
        household {
          id
          primary {
            person {
              id
              firstName
              lastName
            }
          }
        }
        people {
          id
          primary
          firstName
          lastName
          relationship
          birthMonth
          birthYear
        }
      }
    }
  }
`;

export const EVENT = gql`
  query EVENT($id: ID) {
    event(id: $id) {
      id
      name
      date
      startTime
      endTime
      staffStartTime
      staffEndTime
      program {
        id
      }
      leader {
        id
      }
      notes
      published
      constraintCapacityTotal
      constraintAllowGroupRegistration
      constraintStaff
      registrationOpenDate
      earlyRegistrationOpenDate
      constraintCapacityGroup
      constraintPrivate
      constraintAllowEarlyRegistration
      communications {
        id
        name
        timing
        subject
        type
        program
        body
        parent
        useParent
        date
      }
      program {
        id
        name
        description
        shortDescription
        organization
        addressLineOne
        addressLineTwo
        city
        state
        postal
        location {
          id
        }
        coordinator {
          id
        }
        category {
          id
        }
        secondaryCategory {
          id
        }

        contacts {
          name
          email
          phone
        }

        sponsors {
          id
        }

        communications {
          id
          name
          timing
          subject
          type
          program
          body
        }

        partnerQuote
        takeNote
        notes
        headerImage
        cardImage

        annualSchedule
        monthlyBudget

        constraints {
          capacity
          minAge
          staff
        }
      }
    }
  }
`;

export const ADMIN_ADD_REGISTRATION = gql`
  mutation($input: EventRegistrationInput) {
    adminAddRegistration(input: $input)
  }
`;

export const MOVE_FROM_WAITLIST = gql`
  mutation($id: String) {
    moveFromWaitlist(id: $id)
  }
`;

export const RELEASE_WAITLIST = gql`
  mutation($input: ReleaseWaitlistInput) {
    releaseRegistrations(input: $input) {
      id
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation($input: EventInput) {
    updateEvent(input: $input) {
      id
    }
  }
`;

export const ADD_EVENT = gql`
  mutation($input: EventInput) {
    addEvent(input: $input) {
      id
    }
  }
`;
